<template>
  <div v-if="!isLoading">
    <div class="adult-password-wrap adult-05">
      <h1 class="logo a11y-hidden">
        <img v-if="isWavveOn" :src="require(`@/assets/images/common/ci-pooqzone.png`)" alt="POOQZONE" />
        <img :src="require(`@/assets/images/common/ci-wavve.svg`)" alt="Wavve" />
      </h1>

      <img
        :src="require(`@/assets/images/common/ico-common-19.png`)"
        alt="19"
        class="adult-icon"
      />

      <div class="adult-explain-box" tabindex="0">
        <h2 class="adult-title">
          <span>성인 인증</span>
        </h2>
        <p class="adult-explain">
          <span>이 정보 내용은 청소년 유해물로부터 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 및</span>
          <span>‘청소년 보호법’에 따라 19세 미만의 청소년이 이용할 수 없습니다.</span>
          <span v-if="isDownload" class="adult-date">성인 인증 후 다시 다운로드 진행해주시길 바랍니다.</span>
        </p>
      </div>

      <span
        v-if="isAdultVerified"
        class="adult-date"
      >
        성인인증일자: {{ dataUser.adultverification }}
      </span>

      <div class="button-box">
        <div class="button-item">
          <button
            type="button"
            @click.prevent="exit()"
            class="button-cancel"
          >
            나가기
          </button>
          <button
            type="button"
            @click.prevent="clickVerification()"
            class="button-confirm"
          >
            성인 인증 후 {{ isDownload ? '다운로드' : '시청하기' }}
          </button>
        </div>
      </div>
    </div>

    <PooqZonePinCode
      v-if="isShowPopup"
      :is-adult="true"
      ref="pincode"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import PooqZonePinCode from '@/components/common/PooqZonePinCode'
import { loginProc } from '@/common/utils/login'
import cookie from '@/common/utils/cookie'
import { getUser, getPooqzoneAdult } from '@/common/utils/request'
import { SET_CURRENT_MENU } from '@/common/resources/const'
import { mapMutations } from 'vuex'
import { titleTagNameChange } from '@/common/utils/common'

export default {
  name: 'Adult',
  components: {
    PooqZonePinCode
  },
  data () {
    return {
      dataUser: undefined,
      isShowPopup: false,
      isWavveOn: cookie.isWavveOn(),
      isLoading: true
    }
  },
  computed: {
    isDownload () {
      return this.$route.query?.download === 'true'
    },
    isAdultVerified () {
      return this.dataUser?.adultverification.length > 0
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    postMessage (e) {
      if (e.origin === location.origin && e.data.eventMessage === 'verifiedAdult') {
        let login = loginProc({ userType: 'credential', userId: cookie.getCredential(), userPassword: '', saveId: '', autoLogin: '', profile: '' })
        let user = getUser().then((response) => {
          this.dataUser = response.data
        })

        // 크리덴셜 로그인, 유저 정보 API 둘 다 성공시에 진입 페이지로 이동
        Promise.all([login, user]).then(() => {
          this.isDownload
            ? this.$router.back()
            : location.reload()
        })
      }
    },
    // 성인 인증 팝업 호출
    clickVerification () {
      if (this.isWavveOn) {
        this.isShowPopup = true
        return
      }
      let locationOrigin = window.location.origin
      if (!locationOrigin) {
        locationOrigin = window.location.protocol + '//' + window.location.hostname
      }
      const callback = encodeURIComponent(`${window.location.origin}/callback.html?action=verifiedAdult&result=`)
      const url = `https://member.wavve.com/auth/verifyage?callback=${callback}`
      const popup = window.open(url, '', 'width=1440, height=800, scrollbars=yes')

      popup.window.focus()
    },
    enter () {
      this.$emit('enter-fn')
    },
    exit () {
      this.isDownload
        ? this.$router.back()
        : this.$emit('exit-fn')
    },
    async fetchData () {
      try {
        return await getUser()
      } catch (e) {}
    },
    setData (response) {
      this.dataUser = _.get(response, 'data', {})
    },
    async init () {
      this.isLoading = true
      this[SET_CURRENT_MENU]('ADULT')
      const response = await this.fetchData()
      this.setData(response)
      this.isLoading = false
    }
  },
  created () {
    this.init()
    // 웨이브온 성인인증 팝업 이벤트
    this.$events.$on('setPinCodePage', value => {
      this.isShowPopup = value
    })
    // 웨이브온 성인인증 이벤트
    this.$events.$on('checkAdult', pincode => {
      getPooqzoneAdult({ adultpincode: pincode }).then((response) => {
        if (response.data.adultcertification === 'y') {
          this.enter()
          location.reload()
        } else {
          this.$refs.pincode.resetPincode()
          alert('성인인증번호가 올바르지 않습니다. 다시 입력해 주세요.')
        }
      })
    })
    titleTagNameChange('성인인증 : 웨이브')
  },
  mounted () {
    window.addEventListener('message', this.postMessage)
  },
  beforeDestroy () {
    this.$events.$off('setPinCodePage')
    this.$events.$off('checkAdult')
    window.removeEventListener('message', this.postMessage)
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/adult.scss" />
<style lang="css">
.a11y-hidden{
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  position:absolute;
  width:1px;
  height:1px
}
/* popup */
.pop-intro{
  width: 340px;
  height: 400px;
  margin: -200px 0 0 -170px;
  background-color: #1b1b1b;
}

.pop-intro .pop-con{
  width: 100%;
  overflow: hidden;
  text-align: center;
}

.pop-intro .pop-con strong{
  font-weight: 700;
  font-weight: 400;
  color: #fff;
  font-size: 20px;
  margin-top: 52px;
  display: block;
}

.pop-intro .pop-con p{
  margin: 10px 0 65px;
  color: #fff;
  opacity: .7;
  font-weight: 400;
  font-size: 14px;
}

.pop-intro .pop-con ul{
  width: 227px;
  margin: 0 auto;
  overflow: hidden;
}

.pop-intro .pop-con ul li{
  float: left;
  margin-right: 25px;
  text-align: center;
  width: 38px;
}

.pop-intro .pop-con ul li:last-child{
  margin-right: 0;
}

.pop-intro .pop-con ul li em{
  display: block;
  width: 4px;
  height: 4px;
  border: 1px solid rgba(255, 255, 255, .5);
  border-radius: 50%;
  text-indent: -9999px;
  margin: 0 0 12px;
  margin-left: 16px;
}

.pop-intro .pop-con ul li em.on{
  width: 6px;
  height: 6px;
  border: 0;
  background: #fff;
}

.pop-intro .pop-con ul li input[type="text"]{
  border: 0;
  border-bottom: 2px solid #fff;
  width: 38px;
  border-radius: 0;
  padding: 0 0 9px;
  text-align: center;
  color: #fff;
  font-weight: 400;
  font-size: 30px;
}

.pop-intro .pop-con .pop-btn{
  overflow: hidden;
  text-align: center;
  margin: 90px 0 0;
}

.pop-intro .pop-con a{
  display: inline-block;
  border-radius: 50px;
  width: 89px;
  height: 46px;
  color: #fff;
  line-height: 46px;
  font-size: 16px;
  font-weight: 700;
  margin-right: 6px;
  background-color: #252525;
}

.pop-intro .pop-con a.btn-confirm{
  background-color: #1351f9;
}
</style>
